import React, { Component } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import _ from 'lodash';

// internal
import MainContainer from './main';
import ListContainer from './list';
import HomeContainer from './home';
import EditShipmentContainer from './EditShipment';
import SignatureContainer from './signature';
import Header from '../components/Header';
import IdScanContainer from './IdScan';
import PODContainer from './pod';
import TimelineCompose from './embed/timeline';
import PageNotfoundContainer from './404';
import ErrorPageContainer from './Error';
import menuItems from '../constants/menuItems';
import Thankyou from 'components/DeliveryManager/Thankyou';
import { ManageDelivery } from 'containers/ManageDelivery';
import { ManageDeliveryContainer, RedirectManageDelivery } from 'containers/AccessCode';
import { ManageDeliveryLite } from 'containers/ManageDeliveryLite';

// Header wrapper that conditionally renders based on route
const HeaderWrapper = () => {
  const location = useLocation();
  if (_.includes(location.pathname, '/404')) {
    return null;
  }
  return <Header menuItems={menuItems} />;
};

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontFamily: '',
    };
  }

  componentDidUpdate() {
    const { pageTheme } = this.props.store.deliveryStore;
    const fontFamily = pageTheme.typography.fontFamily;

    if (fontFamily !== this.state.fontFamily) {
      this.setState({ fontFamily: fontFamily });
      document.body.style.fontFamily = fontFamily;
    }
  }

  componentWillUnmount() {
    document.body.style.fontFamily = '';
  }

  render() {
    const { pageTheme } = this.props.store.deliveryStore;

    return (
      <div style={{ position: 'relative', minHeight: '100vh', fontFamily: pageTheme.typography.fontFamily }}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={pageTheme}>
            <HeaderWrapper />
            <Routes>
              <Route path="/list/:tracking_codes" element={<ListContainer />} />
              <Route path="/list/noredirect/:tracking_codes" element={<ListContainer />} />
              <Route path="/404" element={<PageNotfoundContainer />} />
              <Route path="/noredirect/404" element={<PageNotfoundContainer />} />
              <Route path="/error" element={<ErrorPageContainer />} />
              <Route path="/noredirect/error" element={<ErrorPageContainer />} />
              <Route path="/" element={<HomeContainer />} />
              <Route path="/noredirect/:tracking_code" element={<MainContainer />} />
              <Route path="/showpod/:data" element={<PODContainer />} />
              <Route path="/:tracking_code/signature" element={<SignatureContainer />} />
              <Route path="/:tracking_code/timeline" element={<TimelineCompose />} />
              <Route path="/:tracking_code/v2/edit/*" element={<EditShipmentContainer />} />
              <Route path="/:tracking_code/idscan/*" element={<IdScanContainer />} />
              <Route path="/:trackingCode/delivery" element={<RedirectManageDelivery />} />
              <Route path="/:trackingCode/sessions/completed" element={<Thankyou />} />
              <Route path="/:trackingCode/sessions" element={<ManageDeliveryContainer />} />
              <Route path="/:trackingCode/edit" element={<ManageDelivery />} />
              <Route path="/:trackingCode/access-code" element={<ManageDeliveryLite />} />
              <Route path="/:tracking_code" element={<MainContainer />} />
            </Routes>
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    );
  }
}

const RootCompose = compose(inject('store'), observer)(AppContainer);

export default RootCompose;
